export const knownErrors = [{
  message: 'Contact already exists. Existing ID:',
  status: 409
}, {
  message: 'Connected calendar not found',
  status: 404
}, {
  message: 'Calendar connection error',
  status: 403
}, {
  message: 'Request aborted',
  status: 0
}, {
  message: 'Resource not found',
  // deal amount settings
  status: 404
}, {
  message: 'No connected calendar found',
  status: 404
}];
export const authenticationErrors = {
  userIdIsNotSet: `User ID isn't set for Session`,
  portalNotConnected: 'Portal not connected',
  sessionNotFound: 'Session not found',
  cookieNotFound: 'Any of the listed authentication credentials are missing',
  noPortalInUrl: 'Unable to deduce portalId from this request'
};
export const ERROR_CALLBACK_TYPES = {
  callObject: 'callObject',
  authentication: 'authentication'
};